// extracted by mini-css-extract-plugin
export default {"cleopatra":"cleopatra_cleopatra__a6yH7","closeButton":"cleopatra_closeButton__WfxyB"};